import { FormControl, InputLabel } from "@material-ui/core";
import React from "react";
import { components } from "react-select";
import AsyncSelect from "react-select/async";

const NoOptionsMessage = (props) => {
  return (
    <components.NoOptionsMessage {...props}>
      Sin resultados
    </components.NoOptionsMessage>
  );
};

const LoadingMessage = (props) => {
  return (
    <components.LoadingMessage {...props}>
      Cargando...
    </components.LoadingMessage>
  );
};

const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: "9999 !important" }),
  option: (styles, { data }) => {
    return {
      ...styles,
      color: data["disabled"] ? "red" : "black",
    };
  },
};

const DropdownIndicator = () => null;
const IndicatorSeparator = () => null;

export const CSearchSelect = (props) => {
  const {
    loadOptions,
    optionsData,
    onChange,
    placeHolder,
    name,
    label,
    disabled,
    value,
    clearable,
    className,
    maxMenuHeight,
    readOnly,
    isOpenMenu,
    isMulti,
  } = props;
  const customComponents = { NoOptionsMessage, LoadingMessage };
  const customComponentsReadOnly = {
    ...customComponents,
    DropdownIndicator,
    IndicatorSeparator,
  };
  const widht = label ? label.length * 10 : 0;

  return (
    <FormControl variant="outlined" fullWidth={true} size="small">
      <InputLabel
        id="test-select-label"
        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl 
        MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-marginDense 
        MuiInputLabel-outlined Mui-disabled Mui-disabled MuiFormLabel-filled"
        style={{
          backgroundColor: "#FFFFFF",
          width: { widht },
          paddingInline: 5,
        }}
      >
        {label ? label : ""}
      </InputLabel>
      <AsyncSelect
        isMulti={isMulti}
        className={className ?? ""}
        styles={selectStyles}
        placeholder={placeHolder}
        name={name}
        value={value}
        getOptionLabel={(e) => e.text}
        getOptionValue={(e) => e.value}
        cacheOptions
        options={optionsData}
        loadOptions={loadOptions}
        onChange={onChange}
        isDisabled={disabled ?? false}
        maxMenuHeight={maxMenuHeight ?? undefined}
        isClearable={clearable ?? true}
        openMenuOnClick={isOpenMenu ?? true}
        isSearchable={!readOnly}
        components={!readOnly ? customComponents : customComponentsReadOnly}
      />
    </FormControl>
  );
};
